import "~/misc/common";
import { Controller } from "@hotwired/stimulus";
import { Chart } from "chart.js";

export default class extends Controller {
	connect() {
		const colors = ["#109618", "#ff9900", "#DC3912"];
		const column_data = $('#toJs').data('columndata');
		const ctx = $('#column')[0] as HTMLCanvasElement;
		const chart = new Chart(ctx, {
			type: 'bar',
			data: {
				datasets: [{
					label: 'Kötelező',
					backgroundColor: colors[2],
					borderColor: colors[2],
					data: column_data.obl,
				}, {
					label: 'Fakultatív',
					backgroundColor: colors[0],
					borderColor: colors[0],
					data: column_data.fac,
				}],
				labels: column_data.labels,
			},
			options: {
				indexAxis: 'y',
				scales: {
					x: {
						title: { display: true, text: 'Létszám' },
						min: 0,
						stacked: true
					},
					y: {
						stacked: true
						//maxBarThickness: 40,
					},
				},
				plugins: {
					tooltip: {
						callbacks: {
							label: function (ctx) {
								return `${ctx.parsed.x} tag`;
							}
						}
					},
					legend: {
						display: true,
						labels: { usePointStyle: true }
					}
				},
				maintainAspectRatio: false,
			}
		});
	}
}
